import { css } from '@emotion/react';
import { t } from 'i18n';
import { CommonTraveler } from 'models';

import { LegacyCard } from '../../LegacyCard';
import { theme } from '../../theme';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
  `,
  divider: css`
    background-color: ${theme.colors.separator};
    width: 100%;
    margin-block: 0;
  `,

  wrapper: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: bottom;
    @media (max-width: ${theme.breakpoints.tablet}) {
      flex-direction: column;
    }
  `,
  labelContainer: css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing.xl};
    margin-top: ${theme.spacing.md};
    @media (max-width: ${theme.breakpoints.tablet}) {
      flex-direction: column;
      gap: ${theme.spacing.md};
    }
  `,
  detailsContainer: css`
    display: flex;
    flex-direction: column;
  `,
};

type Props = {
  passenger: CommonTraveler | undefined;
  className?: string;
};

export const ContactDetails = ({ passenger, className }: Props) => {
  const email = passenger?.email;
  const phone = passenger?.phone;

  if (!email || !phone) return null;

  return (
    <LegacyCard css={styles.container} className={className}>
      <h3>{t('common:myContactDetails')}</h3>
      <hr css={styles.divider} />
      <div css={styles.wrapper}>
        <div css={styles.labelContainer}>
          <div css={styles.detailsContainer}>
            <h4>{t('common:email')}</h4>
            <span>{email}</span>
          </div>
          <div css={styles.detailsContainer}>
            <h4>{t('common:phone')}</h4>
            <span>{phone}</span>
          </div>
        </div>
      </div>
    </LegacyCard>
  );
};
